import type { TourDefinition } from "@/types/tour";

export const terminusAdminOnboarding: TourDefinition = {
  id: "terminus-admin-onboarding",
  context: "terminus-admin",
  version: 2,
  path: "/market-insights",
  steps: [
    {
      popover: {
        title: "Welcome to Terminus",
        description:
          "A quick tour of the workspace. You'll see where market research becomes opportunities, how committees decide, and how approved opportunities are shaped into project leads.",
      },
    },
    {
      element: '[data-tour-id="sidebar-research-center"]',
      popover: {
        title: "Research Center",
        description:
          "Market Insights and Dealflow live here. Upload market research and the AI extracts opportunities and their solutions; browse the startup database under Dealflow.",
      },
    },
    {
      element: '[data-tour-id="sidebar-committee"]',
      popover: {
        title: "Committee",
        description:
          "Run the pre-committee review and meeting: approve or reject opportunities and their solutions, and generate the committee reports.",
      },
    },
    {
      element: '[data-tour-id="sidebar-post-committee"]',
      popover: {
        title: "Post-Committee",
        description:
          "Assemble project leads from a closed committee's approved opportunities — review each one, split or merge them, and assign them into project leads.",
      },
    },
    {
      element: '[data-tour-id="sidebar-project-leads"]',
      popover: {
        title: "Project Leads",
        description:
          "The shaping containers: group opportunities, attach supporting assets, generate a one-pager, and finalize a lead into a Project.",
      },
    },
    {
      element: '[data-tour-id="topnav-search"]',
      popover: {
        title: "Quick Search",
        description:
          "Use the search bar or press Cmd+K to quickly find startups, opportunities, and more across the platform.",
      },
    },
    {
      element: '[data-tour-id="topnav-tour-button"]',
      popover: {
        title: "Replay Tour",
        description:
          "You can replay this tour, or the tour for any section, anytime from this button.",
      },
    },
  ],
};
